/* ++++++++++ --------------- EXPORT : DATA IMPRESSIONS : STYLES --------------- ++++++++++ */
export default theme => ({
    impressions:{

    }
});
